import { useDispatch } from "react-redux";
import SidePanel from "../../Components/SidePanel";
import TopBar from "../../Components/Header";
// import csvToJson from "convert-csv-to-json";
import Papa from "papaparse";
import { useRef, useState } from "react";
import api from "../../Core/api";
export default function Home() {
  const [CsvFile, setCsvFile] = useState("");
  const [CsvFileName, setCsvFileName] = useState("");
  const [JsonData, setJsonData] = useState([]);
  const [TableHead, setTableHead] = useState([]);
  const [Loading, setLoading] = useState(false);
  const Ref = useRef();
  const ExpectData = [
    "id",
    "created_time",
    "ad_id",
    "ad_name",
    "adset_id",
    "adset_name",
    "campaign_id",
    "campaign_name",
    "form_id",
    "form_name",
    "is_organic",
    "platform",
    "lead_status",
  ];

  const dispatch = useDispatch();

  const handleCsvFile = (e) => {
    e.preventDefault();
    setLoading(true);
    const JsonFile = [];
    Papa.parse(CsvFile, {
      complete: async function (results) {
        for (let i = 1; i < results?.data?.length; i++) {
          let JsonObject = {};
          let Comments = "";
          setTableHead(results.data[0]);
          for (let j = 0; j < results?.data[i]?.length; j++) {
            if (
              results.data[0][j] === "full_name" ||
              results.data[0][j] === "email" ||
              results.data[0][j] === "phone_number"
            ) {
              
              if (results.data[0][j] === "email") {
                console.log(results?.data[i][j],results?.data[i],results?.data[0][j])
                const { data } = await api.post("/other/uploadcsv/emailCheck", {
                  email: results?.data[i][j],
                  
                });
                JsonObject["Contact_Id"] = data?.Result[0]?.Contact_Id || "NOT IN CRM";
              }

              JsonObject[results.data[0][j]] = results?.data[i][j];
            } else {
              if (!ExpectData.includes(results.data[0][j])) {
                Comments += `<tr> <td>${results.data[0][j]}</td>: <td>${results?.data[i][j]}</td> </tr> <br/>`;
              }
            }
          }
          JsonObject["comments"] = Comments;

          if (JsonObject.id !== "") {
            JsonFile.push(JsonObject);
          }
        }

        setJsonData(JsonFile);
        setCsvFile("");
        Ref.current.value = "";
        setLoading(false);
      },
    });
  };

  return (
    <>
      <SidePanel page={"File"} />
      <section className="home-section">
        <TopBar Heading={"File Upload"} />
        <div className="home-content" style={{ paddingTop: "90px" }}>
          <form onSubmit={handleCsvFile} className="Upload_Csv">
            <div>
              <p>
                Upload CSV File <span className="req">*</span>{" "}
              </p>
            </div>

            <div>
              <input
                type="file"
                id="File"
                ref={Ref}
                file={CsvFile}
                onChange={(e) => {
                  setCsvFile(e.target.files[0]);
                  setCsvFileName(e.target.files[0]?.name);
                }}
              />
            </div>

            <div>
              <input
                disabled={Loading}
                className="cst_btn"
                type="submit"
                value={Loading ? "Loading..." : "Upload"}
              />
            </div>
          </form>
        </div>
        <div style={{ padding: "20px" }}>
          <div className="shortlistedcours-main ongoing-applications-main">
            <div>
              <p>{CsvFileName}</p>
              <div className="Student_Table">
                <div className="coctacts-table">
                  <div className="table-responsive custom-scroll-right-bottum">
                    <table className="table  table-condensed">
                      <thead className="t-head-th-bg">
                        <tr>
                          {/* {TableHead?.map((el, i) => (
                            <th className="t-head-fixed" key={i + 7899}>
                              {el}
                            </th>
                          ))} */}
                          <th>Full Name</th>
                          <th>Email Address</th>
                          <th>Phone No</th>
                          <th>Contact Id</th>
                          <th>Comments</th>
                        </tr>
                      </thead>

                      <tbody className="table-bordered">
                        {JsonData.map((ev) => (
                          <tr>
                            <td>{ev?.full_name}</td>
                            <td>{ev?.email}</td>
                            <td>{ev?.phone_number}</td>
                            <td>{ev?.Contact_Id}</td>
                            {/* <td>{ev?.comments}</td> */}
                            <p>
                              <div
                                contentEditable="false"
                                dangerouslySetInnerHTML={{
                                  __html: ev?.comments,
                                }}
                              ></div>
                            </p>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="Total_records">
                    <h5>Total Records {JsonData?.length || 0}</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
